export default "__VITE_ASSET__CBYa7WCS__"